import upperCloud from "../assets/UpperClode.png"
import lowerCloud from "../assets/LowerCloud.png"
import "./Cloud.css"

const Cloud = () => {


    return(
        <div className="Cloud">
            <img src={upperCloud} alt="" />
            <img src={lowerCloud} alt="" />
        </div>
    )
}

export default Cloud